import { render, staticRenderFns } from "./testChart2.vue?vue&type=template&id=170443b3&"
import script from "./testChart2.vue?vue&type=script&lang=js&"
export * from "./testChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports